import React from "react";

const TableRow = ({ data }) => {

    return (
        <tr>
            {data.map((item,index) => {
                if(item){
                    return (
                    <td key={index} className={item.toLowerCase() === "yes" || item.toLowerCase() === "no" ? "icon-show":"icon-hide"}>
                        {item.toLowerCase() === "yes" ? <i className='icon-tick'></i>: item.toLowerCase() === "no" ? <i className="icon-cross"></i> : item}
                    </td>
                    )
                }
            })}
        </tr>
    );
    
};

export default TableRow;